import { CompactMarkdown } from "@/components/ui/Markdown/CompactMarkdown";

interface AnimatedMessageContentViewProps {
  content: string;
  isRevealing: boolean;
}

export const AnimatedMessageContentView = ({
  content,
  isRevealing,
}: AnimatedMessageContentViewProps) => {
  return (
    <CompactMarkdown
      content={content}
      className={
        isRevealing
          ? `[&>*:last-child]:after:ml-px [&>*:last-child]:after:inline-block [&>*:last-child]:after:animate-caret [&>*:last-child]:after:text-primary [&>*:last-child]:after:content-['▋']`
          : ""
      }
    />
  );
};
